
<template>
  <div id="user-data" v-if="user_data">
    <div class="vx-row" id="page-user-view">
      <div class="vx-col w-full">
        <vx-card id="vx-card1" title="Expenses 2024">
          <vs-tabs alignment="fixed">
            <vs-tab label="Total" icon-pack="feather" icon="icon-activity">
              <table id="table1" class="mt-8">
                <tr id="tr1">
                  <th id="th1" style="text-align: left;">Currency</th>
                  <th id="th1">Jan</th>
                  <th id="th1">Feb</th>
                  <th id="th1">Mars</th>
                  <th id="th1">Apr</th>
                  <th id="th1">May</th>
                  <th id="th1">June</th>
                  <th id="th1">July</th>
                  <th id="th1">Aug</th>
                  <th id="th1">Sep</th>
                  <th id="th1">Oct</th>
                  <th id="th1">Nov</th>
                  <th id="th1">Dec</th>
                  <th id="th1">Total</th>
                </tr>
                <tr id="tr1" v-for="data in user_data" :key="data.currency">
                  <td id="td1" style="text-align: left;">Expenses Excl. Tax. {{ data.currency }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.janvier) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.fevrier) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.mars) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.avril) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.mai) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.juin) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.juillet) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.aout) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.septembre) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.octobre) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.novembre) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.decembre) }}</td>
                  <td id="td1" style="color:black"><b>{{ formatDecimalNumber(data.total) }}</b></td>
                </tr>
                <tr id="tr1" v-for="data in user_data" :key="data.currency">
                  <td id="td1" style="text-align: left;">Tax. in {{ data.currency }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_janvier) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_fevrier) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_mars) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_avril) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_mai) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_juin) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_juillet) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_aout) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_septembre) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_octobre) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_novembre) }}</td>
                  <td id="td1">{{ formatDecimalNumber(data.tva_decembre) }}</td>
                  <td id="td1" style="color:black"><b>{{ formatDecimalNumber(data.tva_total) }}</b></td>
                </tr>
              </table>
              <vs-alert class="mt-8" color="success" title="Total" active="true">Total Excl. Tax : {{
                formatDecimalNumber(user_data[1].total)
              }} {{ user_data[1].currency
}} <br />Total Excl. Tax : {{ formatDecimalNumber(user_data[0].total) }} {{ user_data[0].currency
}}</vs-alert>
            </vs-tab>
            <vs-tab label="Group by Accounts" icon-pack="feather" icon="icon-list">
              <vs-alert class="mt-8" color="warning" active="true">
                IN PROGRESS...
              </vs-alert>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import "jspdf-autotable";
import moment from "moment";
import { AmiriRegular } from "@/assets/fonts/Amiri-Regular-normal.js";
import axios from "@/axios.js";


export default {
  components: {
  },
  data() {
    return {
      user_data: null,
    };
  },
  computed: {
  },
  methods:
  {
    formatDecimalNumber(value) {
      if (value === '0' || value === '0.00') {
        return '-';
      }
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  },
  created() {
    if (!localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the Finance page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({path:"/"})
    
    }
    // Register Module UserManagement Module
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.$store
      .dispatch("operationList/fetchExpensesDashboard")
      .then(res => {
        this.user_data = res.data;
      })
      .catch(err => {
        console.error(err);
      });
  }
};
</script>

<style lang="scss">
#vx-card1 {
  font-family: 'Arial', sans-serif;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  padding: 20px;

}

#table1 {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
  /* Assure que le contenu ne dépasse pas les coins arrondis */
}

#th1 {
  background-color: #428373;
  color: white;
  text-align: left;
  padding: 12px 15px;
  font-size: 16px;
  text-align: right;
}

#td1 {
  border-bottom: 1px solid #ddd;
  padding: 10px 15px;
  color: #333;
  font-size: 14px;
  text-align: right;
}

#tr1:nth-child(even) {
  background-color: #f2f2f2;
}

#tr1:hover {
  background-color: #ddd;
  cursor: pointer;
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
